/**
 * Get all mandatory field keys from a student or teacher input config.
 * Handles both sectioned (studentinputs) and flat (teacherinputs) structures.
 */
export function getMandatoryFields(inputConfig: any): string[] {
  // If inputConfig is an array of objects with 'label', treat as flat (teacherinputs)
  if (Array.isArray(inputConfig) && inputConfig.length && inputConfig[0].key) {
    return inputConfig.filter((field: any) => field.mandatory).map((field: any) => field.key);
  }
  // If inputConfig is an array with sections (studentinputs)
  if (Array.isArray(inputConfig) && inputConfig.length && typeof inputConfig[0] === "object") {
    const fields: string[] = [];
    Object.values(inputConfig[0]).forEach((section: any) => {
      section.forEach((field: any) => {
        if (field.mandatory) fields.push(field.key);
      });
    });
    return fields;
  }
  return [];
}

/**
 * Validate form data against mandatory fields.
 * Returns an object with error messages for missing fields.
 */
export function validateForm(
  formData: Record<string, any>,
  mandatoryFields: string[]
): { [key: string]: string } {
  const newErrors: { [key: string]: string } = {};
  mandatoryFields.forEach((key) => {
    if (
      formData[key] === "" ||
      formData[key] === null ||
      formData[key] === undefined
    ) {
      newErrors[key] = "This field is required";
    }
  });
  return newErrors;
}